import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      header: {
        margin: theme.spacing(4, 0),
        color: sicrediColor.secondarySicrediDarker,
      },
      subtitle: {
        fontFamily: '"Exo 2", sans-serif',
        fontWeight: 300,
        fontSize: 12,
        lineHeight: '24px',
        marginTop: theme.spacing(1.5),
      },
    }),
  {
    name: 'ProximosEventos',
  }
);
